import { CreditCardTwoTone } from "@ant-design/icons";
import { LightCardDto } from "../../../generated/dashboard-client";
import { useMemo } from "react";
import "./CardOnFile.scss";

interface CardOnFileProps {
  card: LightCardDto;
  width?: string | number;
  hideCardEnding?: boolean;
}

export default function CardOnFile({
  card,
  width,
  hideCardEnding,
}: CardOnFileProps) {
  const cardExpirationDate = useMemo(() => {
    if (!card.exprMonth || !card.exprYear) return '****';
    const month = card.exprMonth < 10 ? `0${card.exprMonth}` : card.exprMonth;
    const year = card.exprYear % 100;
    return `(exp ${month}/${year})`;
  }, [card]);

  return (
    <section className={"card-info"} style={{ width }}>
      <h5>
        <CreditCardTwoTone />
        Card on file
      </h5>
      <p>
        **** **** ****{" "}
        {hideCardEnding ? "****" : `${card.ending} ${cardExpirationDate}`}
      </p>
    </section>
  );
}
